import { MantineThemeOverride } from '@mantine/core';

export type SegmentedControlTheme = NonNullable<MantineThemeOverride['components']>['SegmentedControl'];

export const SegmentedControl: SegmentedControlTheme = {
  // todo: define
};
